module.exports = __webpack_public_path__ + "img/back.f9add6b3.svg";